import React from 'react';

const Myorder = () => {
    return (
        <div>
            <h2>My order</h2>
        </div>
    );
};

export default Myorder;